import React from 'react';
import {EventoFields, EventoRequestFields, EventoVistaDTO, SchemaFiltroEventos} from "../api/schemas";
import {HttpEvento} from "../api/httpEvento";
import {ItecColFilters, ItecDataGrid, ItecGridColsDef as GridColsDef, useItecDataGrid} from "src/lib/itaptec/datagrid/src";
import {Card, CardHeader, IconButton, Tooltip, Typography} from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import {WrapperTable} from "../../cruds/components";
import {HttpCacheEvento} from "../api/httpCacheEvento";

function TablaEventos() {

    const filtros: ItecColFilters<SchemaFiltroEventos> = {
        descEventoTipo: {
            type: 'select',
            name: EventoFields.CodEventoTipo,
            props: {
                sx: {
                    width: '400px'
                },
                getOptions: () =>
                    HttpCacheEvento.getTipos().then(res =>
                        res.map(s => ({
                            value: s.id,
                            label: s.descripcion,
                        }))
                    ),
            }
        },
        [EventoFields.Fecha]: {
            type: 'date-range',
            name: EventoRequestFields.FechaDesde,
            props: {
                startDateName: 'fechaDesde',
                endDateName: 'fechaHasta'
            }
        }

    }

    const columnas: GridColsDef<EventoVistaDTO>[] = [
        {
            headerName: 'Evento',
            field: EventoFields.DescEventoTipo,
            flex: 3
        },
        {
            headerName: 'Fecha',
            field: EventoFields.Fecha,
            flex: 2,

            type: 'date',
            valueGetter: (params) => new Date(params.value),
            valueFormatter: ({value}) => new Intl.DateTimeFormat('es-Ar', {
                year: 'numeric', month: '2-digit', day: '2-digit'
            }).format(value)
        },
        {
            headerName: 'Observaciones',
            field: EventoFields.Observaciones,
            flex: 6,
            renderCell: ({row: evento}) => (
                <Tooltip title={evento[EventoFields.Observaciones]}>
                    <Typography
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                    >{evento[EventoFields.Observaciones]}</Typography>
                </Tooltip>
            )
        },
        {
            headerName: 'Usuario',
            field: EventoFields.DescUsuario,
            flex: 2
        },

    ]

    const {
        datagridProps,
        control: {
            query: {refetch}
        }
    } = useItecDataGrid({
        pagination: true,
        columns: columnas,
        getEntitiesPaginated: (pagination, filter) =>
            HttpEvento.getEventos(
                pagination,
                filter
                    ? {
                        codEventoTipo: filter[EventoFields.CodEventoTipo]?.value,
                        [EventoRequestFields.FechaDesde]: filter[EventoRequestFields.FechaDesde],
                        [EventoRequestFields.FechaHasta]: filter[EventoRequestFields.FechaHasta]
                    }
                    : {}
            ),
        density: 'compact',
        filters: filtros
    })

    return (
        <WrapperTable>
            <Card>
                <CardHeader
                    title='Auditoría de eventos'
                    action={
                        <IconButton disabled={datagridProps.loading} onClick={() => refetch()}>
                            <CachedIcon/>
                        </IconButton>
                    }
                />
                <ItecDataGrid {...datagridProps} />
            </Card>
        </WrapperTable>
    );
}

export default TablaEventos;